import { HttpClient } from '@adapters/HttpClient';

export interface UpdateBillingRequest {
  invoice_wallet_compensation: boolean;
  wallet_visible: boolean;
  holded_id: string | null;
  holded_client_account: string | null;
  taxes: string[];
  billing_frequency: 'weekly' | 'monthly' | 'biweekly';
  cod_advance_days_after_delivery: number;
  invoice_expiration: number;
  minimum_monthly_fee: number | null;
  minimum_monthly_fee_grace_months: number | null;
}

export class ClientBillingApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async updateBilling(teamId: number, data: UpdateBillingRequest): Promise<void> {
    await this.httpClient.put(`/teams-child/${teamId}/billing`, data);
  }
}
